import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import OpenServiceAll from './openservicesall';
import OpenServiceClient from './openservicesclient';
import Noofopenservices from '../IMCTable/Noofopenservices';

function OpenService() {
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;

    // console.log("userTeam", userTeam);

    const getUserType = () => {
        if (usertype === 'INDIVIDUAL' || usertype === 'CORPORATE') {
            return <OpenServiceClient />;
        } else {
            if (userTeam === 'Team') {
                return <OpenServiceAll />;
            } else if (userTeam === 'ITeC Team') {
                return <Noofopenservices />;
            }
        }
    };

    return <div>{getUserType()}</div>;
}
export default OpenService;
